type LogLevel = 'debug' | 'info' | 'warn' | 'error';

class Logger {
    private formatArgs(args: any[]): any[] {
        return args.map(arg => {
            if (typeof arg === 'object') {
                return JSON.stringify(arg, null, 2);
            }
            return arg;
        });
    }

    private log(level: LogLevel, message: string, ...args: any[]) {
        const timestamp = new Date().toISOString();
        const prefix = `[${timestamp}] ${level.toUpperCase()}:`;
        const formattedArgs = this.formatArgs(args);

        switch (level) {
            case 'debug':
                console.debug(prefix, message, ...formattedArgs);
                break;
            case 'info':
                console.info(prefix, message, ...formattedArgs);
                break;
            case 'warn':
                console.warn(prefix, message, ...formattedArgs);
                break;
            case 'error':
                console.error(prefix, message, ...formattedArgs);
                break;
        }
    }

    debug(message: string, ...args: any[]) {
        this.log('debug', message, ...args);
    }

    info(message: string, ...args: any[]) {
        this.log('info', message, ...args);
    }

    warn(message: string, ...args: any[]) {
        this.log('warn', message, ...args);
    }

    error(message: string, ...args: any[]) {
        // Фильтруем некритичные ошибки WebSocket (Vite HMR)
        if (message.includes('WebSocket error') && args.length > 0) {
            const firstArg = args[0];
            if (typeof firstArg === 'object' && firstArg !== null) {
                const errorObj = firstArg as any;
                // Игнорируем ошибки Vite HMR WebSocket (они не критичны)
                if (errorObj.isTrusted === true && 
                    (!errorObj.url || errorObj.url.includes('localhost:3000') || errorObj.url.includes('vite'))) {
                    // Логируем как debug вместо error
                    this.log('debug', message, ...args);
                    return;
                }
            }
        }
        this.log('error', message, ...args);
    }
}

export const logger = new Logger();